"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _reactTable = require("@tanstack/react-table");
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _Button = require("../../form/Button/Button");
var _paginationHelper = require("../../../helpers/paginationHelper");
var _config = _interopRequireDefault(require("../../../config"));
require("./Table.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var sortIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  width: "7",
  height: "13",
  viewBox: "0 0 7 13",
  fill: "none"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M3.19971 0L5.79778 4.5H0.601631L3.19971 0Z",
  className: "desc"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M3.19971 13L0.601631 8.5L5.79778 8.5L3.19971 13Z",
  className: "asc"
}));

/**
 * Table component with pagination, sorting, filtering and sticky columns.
 *
 * Other than the [predefined parameters](https://tanstack.com/table/latest/docs/api/core/column-def)
 * for the column definition, this component also supports these additional configuration options:
 *  - `className`: additional class for the <td> or <th> element
 *  - `meta`: optional extra meta data assosiated with a column:
 *    * `meta.textAlign`: align the text in the header/cell (default 'left' and also 'center', 'right')
 *    * `meta.fixedWidth`: sets a fixed width for the column, specified in the `size` parameter,
 *        otherwise the width is calculated automatically by the browser
 *
 * @param {Object} props
 * @param {Array} props.data Data to display in the table.
 * @param {Array} props.columns Columns definition.
 * @param {string} [props.className] Additional class names to add to the table.
 * @param {{left?: Array<string>; right?: Array<string>}} [props.stickyColumns] Sticky columns configuration. If omitted, no sticky columns will be displayed.
 * @param {boolean} [props.loading] Display a loading spinner when true.
 * @param {string} [props.emptyMessage] Message to display when there is no data to display.
 * @param {{ pageIndex?: number; pageSize: number; variant: 'simple' | 'extended' }} [props.pagination] Pagination initial configuration. If omitted, pagination will not be displayed.
 * @param {boolean} [props.scrollable] If true, the table will be scrollable (sticky header) filling the available height except the pagination.
 * @returns
 */
var Table = exports.Table = function Table(_ref) {
  var _stickyColumns$left, _stickyColumns$right;
  var data = _ref.data,
    columns = _ref.columns,
    className = _ref.className,
    stickyColumns = _ref.stickyColumns,
    loading = _ref.loading,
    emptyMessage = _ref.emptyMessage,
    initialPagination = _ref.pagination,
    scrollable = _ref.scrollable,
    rowClassName = _ref.rowClassName;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var _React$useState = _react["default"].useState(_objectSpread({
      pageIndex: 0,
      pageSize: 10
    }, initialPagination)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    pagination = _React$useState2[0],
    setPagination = _React$useState2[1];
  var paginationVariant = (initialPagination === null || initialPagination === void 0 ? void 0 : initialPagination.variant) || 'extended';
  var hasStickyColumns = (stickyColumns === null || stickyColumns === void 0 || (_stickyColumns$left = stickyColumns.left) === null || _stickyColumns$left === void 0 ? void 0 : _stickyColumns$left.length) > 0 || (stickyColumns === null || stickyColumns === void 0 || (_stickyColumns$right = stickyColumns.right) === null || _stickyColumns$right === void 0 ? void 0 : _stickyColumns$right.length) > 0;
  var hasSorting = columns.some(function (column) {
    return column.enableSorting;
  });
  var table = (0, _reactTable.useReactTable)({
    data: data,
    columns: columns,
    state: {
      columnPinning: stickyColumns !== null && stickyColumns !== void 0 ? stickyColumns : {},
      pagination: initialPagination ? pagination : undefined
    },
    defaultColumn: {
      size: 100,
      //starting column size
      minSize: 50
    },
    getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
    onPaginationChange: initialPagination ? setPagination : undefined,
    getPaginationRowModel: initialPagination ? (0, _reactTable.getPaginationRowModel)() : undefined,
    getSortedRowModel: hasSorting ? (0, _reactTable.getSortedRowModel)() : undefined
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('ap-table__container', className, {
      'ap-table__container--scrollable': scrollable,
      'ap-table__container--paginated': !!initialPagination
    })
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "ap-table"
  }, /*#__PURE__*/_react["default"].createElement("thead", null, table.getHeaderGroups().map(function (headerGroup) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: headerGroup.id
    }, headerGroup.headers.map(function (header) {
      var _header$column$column, _header$column$column2;
      return /*#__PURE__*/_react["default"].createElement("th", {
        key: header.id,
        className: (0, _classnames["default"])({
          'align-right': ((_header$column$column = header.column.columnDef.meta) === null || _header$column$column === void 0 ? void 0 : _header$column$column.textAlign) === 'right',
          'align-center': ((_header$column$column2 = header.column.columnDef.meta) === null || _header$column$column2 === void 0 ? void 0 : _header$column$column2.textAlign) === 'center',
          'sticky-column': header.column.getIsPinned(),
          'sticky-column--last-left': header.column.getIsLastColumn('left'),
          'sticky-column--last-right': header.column.getIsLastColumn('right')
        }),
        style: hasStickyColumns ? getInlineStyles(header.column) : undefined
      }, header.isPlaceholder ? null : header.column.getCanSort() ? /*#__PURE__*/_react["default"].createElement("button", {
        "aria-sort": {
          asc: 'ascending',
          desc: 'descending'
        }[header.column.getIsSorted()],
        onClick: header.column.getToggleSortingHandler(),
        title: header.column.getCanSort() ? header.column.getNextSortingOrder() === 'asc' ? t('Sort ascending') : header.column.getNextSortingOrder() === 'desc' ? t('Sort descending') : t('Clear sort') : undefined
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "ap-table__header-label"
      }, (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())), sortIcon) : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext()));
    }));
  })), /*#__PURE__*/_react["default"].createElement("tbody", null, loading ? /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
    className: "ap-table--loading",
    colSpan: table.getAllLeafColumns().length
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    text: t('Loading...')
  }))) : table.getRowModel().rows.length === 0 ? /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
    className: "ap-table--empty",
    colSpan: table.getAllLeafColumns().length
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "stop"
  }), emptyMessage))) : table.getRowModel().rows.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.id,
      className: (0, _classnames["default"])(rowClassName ? rowClassName(row) : '')
    }, row.getVisibleCells().map(function (cell) {
      var _cell$column$columnDe, _cell$column$columnDe2;
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: cell.id,
        className: (0, _classnames["default"])({
          'align-right': ((_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : _cell$column$columnDe.textAlign) === 'right',
          'align-center': ((_cell$column$columnDe2 = cell.column.columnDef.meta) === null || _cell$column$columnDe2 === void 0 ? void 0 : _cell$column$columnDe2.textAlign) === 'center',
          'sticky-column': cell.column.getIsPinned(),
          'sticky-column--last-left': cell.column.getIsLastColumn('left'),
          'sticky-column--last-right': cell.column.getIsLastColumn('right')
        }, cell.column.columnDef.className),
        style: hasStickyColumns ? getInlineStyles(cell.column) : undefined
      }, (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext()));
    }));
  })))), !!initialPagination && /*#__PURE__*/_react["default"].createElement("nav", {
    role: "navigation",
    "aria-label": "pagination",
    className: "ap-pagination"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, paginationVariant === 'extended' && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    size: "sm",
    variant: "secondary",
    className: "ap-pagination__button",
    onClick: function onClick() {
      return table.firstPage();
    },
    disabled: !table.getCanPreviousPage(),
    "aria-label": "First Page"
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "doubleCaretPrevious",
    customClass: "arrow previous"
  }))), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    variant: "secondary",
    size: "sm",
    onClick: function onClick() {
      return table.previousPage();
    },
    disabled: !table.getCanPreviousPage(),
    className: "ap-pagination__button",
    "aria-label": "Previous Page"
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "caretPrevious",
    customClass: "arrow previous"
  }), t('Prev'))), paginationVariant === 'simple' || table.getPageCount() <= 1 ? /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    size: "sm",
    className: "ap-pagination__button ap-pagination__button--active",
    "aria-current": "true"
  }, table.getState().pagination.pageIndex + 1)) : (0, _paginationHelper.generateNumberRangeArray)(Math.min(table.getPageCount(), _config["default"].Pagination.maxPages), table.getState().pagination.pageIndex, table.getPageCount()).map(function (page) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: page
    }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      size: "sm",
      variant: table.getState().pagination.pageIndex === page ? 'primary' : 'secondary',
      onClick: function onClick() {
        return table.setPageIndex(page);
      },
      "aria-label": "Page ".concat(page),
      "aria-current": page === table.getState().pagination.pageIndex + 1 ? 'true' : undefined,
      className: page === table.getState().pagination.pageIndex ? 'ap-pagination__button ap-pagination__button--active' : 'ap-pagination__button'
    }, page + 1));
  }), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    size: "sm",
    variant: "secondary",
    className: "ap-pagination__button",
    onClick: function onClick() {
      return table.nextPage();
    },
    disabled: !table.getCanNextPage(),
    "aria-label": "Next Page"
  }, t('Next'), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "caretNext",
    customClass: "arrow next"
  }))), paginationVariant === 'extended' && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    size: "sm",
    variant: "secondary",
    className: "ap-pagination__button",
    onClick: function onClick() {
      return table.lastPage();
    },
    disabled: !table.getCanNextPage(),
    "aria-label": "Last Page"
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "doubleCaretNext",
    customClass: "arrow next"
  }))))));
};
function getInlineStyles(column) {
  var _column$columnDef$met;
  var styles = {};
  if ((_column$columnDef$met = column.columnDef.meta) !== null && _column$columnDef$met !== void 0 && _column$columnDef$met.fixedWidth) {
    styles.width = column.getSize();
  }
  var isPinned = column.getIsPinned();
  if (isPinned === 'left') {
    styles.left = "".concat(column.getStart('left'), "px");
  } else if (isPinned === 'right') {
    styles.right = "".concat(column.getAfter('right'), "px");
  }
  return styles;
}